import './PortalHeader.css';
import IFrameWidgetRenderer from 'components/iframe/IFrameWidgetRenderer';

//
// --- Types ---

export interface PortalHeaderProps {
  isMinimized?: boolean;
  portalId: number;
}

//
// --- PortalHeader Component ---

const PortalHeader: React.FC<PortalHeaderProps> = props => {
  const { isMinimized = false, portalId } = props;

  return (
    <IFrameWidgetRenderer
      className={`supplier-search-portal-pa-${isMinimized ? 'shrunken-' : ''}header`}
      id="portal-header-nav-iframe"
      iframeSrc={`/displaySetupSupplierPortalNav.do?portalId=${portalId}`}
    />
  );
};

export default PortalHeader;
